import type { Directive } from 'vue'
import { checkWebpSupport } from '~/utils/common'

/**
 * OSS图片转换webp格式,并设置图片宽高
 * 使用: v-webpsize="{ w: '200', h: '100' }" w 图片宽度, h 图片高度,单位px（最好使用双倍宽高）
 * 目前使用的地方：展会详情页底部的资讯图片
 * */
const vWebp: Directive = {
  mounted(el, binding) {
    // console.log('webpsize--', binding.value)
    let originalSrc = el.getAttribute('src')
    if (!checkWebpSupport || !originalSrc) return
    if (originalSrc?.includes('undefined')) {
      originalSrc = ''
    }
    originalSrc = formatCover(originalSrc)
    const isCDN = /(aliyuncs.com)|(file.jufair.com)|(.jufair.com)/
    if (isCDN.test(originalSrc) && !originalSrc.includes('?x-oss-process=')) {
      originalSrc = originalSrc?.split('?')[0]
      let w = ''
      let h = ''
      if (binding.value?.hasOwnProperty('w')) {
        w = `w_${binding.value.w}`
      }
      if (binding.value?.hasOwnProperty('h')) {
        h = `h_${binding.value.h}`
      }
      let osssize = `?x-oss-process=image/resize,${w},${h}/format,webp`
      if (el.className.includes('banner-img') || el.className.includes('not-watermark')) {
        //
        if (!originalSrc.includes('!webp')) {
          originalSrc += '!webp'
        }
      } else if (!originalSrc.includes('!swebp')) {
        // 如果图片url不包含!swebp
        // originalSrc += '!swebp'
        originalSrc += w || h ? osssize : '!swebp'
      }
      //   console.log('originalSrc =', originalSrc);
      el.setAttribute('src', originalSrc)
    }
  }
}

export default vWebp
